import React, { useEffect, useState } from "react";
import Table from "../common/Table";
import { useDispatch, useSelector } from "react-redux";
import TableColumn from "./dependencies/TableColumn";
import { useModal } from "../UseModal/UseModal";
import NotificationModal from "./NotificationModal";
import { getItemList } from "./dependencies/action";
import { toDate } from "date-fns";


function PromotionNotification() {
  const dispatch = useDispatch();
  const {showModal: showNotificationModal,openModal: handleOpenNotificationModal,closeModal: handleCloseNotificationModal} = useModal();
  const { ItemList,TotalItemList} = useSelector((state) => state.promotionNotification);

  const [query,setQuery] = useState({ page: 1, limit: 10,fromDate:'',toDate:'' })

  const fetchItemList = () => {
    dispatch(getItemList(query));
  };

  useEffect(() => {
    fetchItemList();
  }, [dispatch, query]);

  const handlePageChange = (page) => {
    setQuery({ ...query, page: page });
  };

  const clearFilter=()=>{
    setQuery({ page: 1, limit: 10,fromDate:'',toDate:'' })
  }
  return (
    <>
      <head>
        <title>Fever99</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </head>
      <div className="page-wrapper">
        <div className="content">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="col-sm-4 col-3">
              <h4 className="page-title">Promotion Notification</h4>
            </div>

          </div>
          <div className="row m-b-20">
          <div className="col-4">
            <label>From Date</label>
            <input
              type="date"
              name="fromDate"
              value={query.fromDate}
              className="form-control"
              onChange={(e) =>  setQuery(prevQuery => ({
                ...prevQuery,
                fromDate: e.target.value,
              }))}
            />
          </div>
          <div className="col-4">
            <label>To Date</label>
            <input
              type="date"
              name="toDate"
              value={query.toDate}
              min={query.fromDate}
              className="form-control"
              onChange={(e) =>  setQuery(prevQuery => ({
                ...prevQuery,
                toDate: e.target.value,
              }))}
            />
          </div>
          <div className="col-4">
            <button className="btn btn-danger ml-2 mt-4" 
            onClick={clearFilter}
            >
              Clear Filter
            </button>
          </div>
        </div>
          <a
            href="#0"
            className="btn btn-sm btn-success mb-1 mt-3"
            onClick={handleOpenNotificationModal}
          >
            Send Notification
          </a>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <Table
                      columns={TableColumn({
                        pageNo: query.page - 1,
                        size: query.size,
                      })}
                      dataTable={ItemList}
                      totalRecord={TotalItemList}
                      onPageChange={handlePageChange}
                      onTableChange={() => { }}
                      keyField="_id"
                      sizePerPage={query.size}
                    // pageSizeChange={(value) => handlePageSizeChange(value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
        <NotificationModal
        show={showNotificationModal}
        handleClose={handleCloseNotificationModal}
        onNotificationSent={fetchItemList}
        />
      
    </>
  );
}

export default PromotionNotification;
